import './jquery-global.js'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'

import '../../../vendor/mason.min.js'

import '../css/style.scss'
